<template>
  <div id="BatchAddMember" class="well" style="padding: 0 1em">
    <b-tabs content-class="mt-3">
      <b-tab title="會員帳號匯入">
        上傳編碼UTF-8 附檔.csv檔案格式如下(含欄位名稱):<a href="general.csv"
          >下載範例檔</a
        ><br />
        <table class="table" style="width: auto; align: left">
          <tbody>
            <tr>
              <td>會員姓名</td>
              <td>身分證字號(帳號)</td>
              <td>行動電話</td>
              <td>電子信箱(認證信箱)</td>
              <td>密碼</td>
              <td>生日</td>

            </tr>

            <tr>
              <td>陳OO</td>
              <td>A123456777</td>
              <td>0911111111</td>
              <td>xxx@ncut.edu.tw</td>
              <td>A123456777</td>
              <td>2022-01-01</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 1em" colspan="6">
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  v-model="file[0]"
                  @input="fileChange(0)"
                  placeholder="上傳csv檔案"
                  accept=".csv"
                ></b-form-file>

                <button
                  href="#"
                  @click.prevent="BatchAddGeneral()"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  送出
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-tab>
      <!-- <b-tab title="企業會員帳號匯入">
        上傳編碼UTF-8 附檔.csv檔案格式如下(含欄位名稱):<a href="enterprise.csv"
          >下載範例檔</a
        ><br />
        <table class="table" style="width: auto; align: left">
          <tbody>
            <tr>
              <td>會員姓名</td>
              <td>身分證字號(帳號)</td>
              <td>行動電話</td>
              <td>電子信箱(認證信箱)</td>
              <td>密碼</td>
              <td>生日</td>

            </tr>

            <tr>
              <td>陳OO</td>
              <td>A123456777</td>
              <td>0911111111</td>
              <td>xxx@ncut.edu.tw</td>
              <td>A123456777</td>
              <td>2022-01-01</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 1em" colspan="6">
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  v-model="file[0]"
                  @input="fileChange(0)"
                  placeholder="上傳csv檔案"
                  accept=".csv"
                ></b-form-file>

                <button
                  href="#"
                  @click.prevent="BatchAddTeacher()"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  送出
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>
import * as tools from '../tool'

export default {
  name: 'BatchAddMember',
  data () {
    return {
      file: [{ name: '' }],
      inputData: {
        tid: '',
        idNo: '',
        name: '',
        jobTitle: '',
        serviceUnit: '',
        cellPhone: '',
        email: ''
      }
    }
  },
  computed: {},
  methods: {
    BatchAddGeneral () {
      var vm = this
      if (vm.file[0].name == '') {
        alert('請上傳csv檔案')
        return
      }

      this.$http
        .get('./WebApi/ociaRep/BatchAddGeneral')
        .then((response) => {
          if (response.data > 0) {
            tools.showAlert(vm, 'success', '匯入檔案成功')
          } else {
            tools.showAlert(vm, 'danger', '匯入檔案失敗，請重新上傳' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗，請重新匯入檔案' + error)
        })
    },

    fileChange (index) {
      var vm = this
      this.formData = new FormData()

      if (index == 0) this.formData.append('header', this.file[0])

      this.$http
        .post('./WebApi/Common/UploadV2', this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) {
              this.file[0] = response.data[0]
            }
          } else {
            tools.showAlert(vm, 'danger', '上傳檔案失敗，請重新上傳' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗，請重新上傳' + error)
        })
    },

    close () {
      this.$emit('hideModal')
    },
    isEmpty (data) {
      return !(data != null && data != undefined && data.length > 0)
    }

  },
  created () {
    console.log('======created View =====')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
